import { ArrowRight } from 'lucide-react';

import Container from '../../Main/sections/Container';
import Reveal from '../../../components/Reveal';
import phone from '../../../assets/images/quiz-phone.png';

const REGISTER_URL = 'https://app.schoolhack.ai/auth/register';

const Hero = () => {
  return (
    <section className="relative overflow-hidden pb-16 pt-14 md:pt-20 lg:pb-24">
      <div className="glow left-1/2 top-[-140px] h-[420px] w-[620px] -translate-x-1/2 bg-accent/16" />
      <div className="glow right-[-120px] top-[120px] h-[360px] w-[360px] bg-accent/10" />
      <div className="pointer-events-none absolute inset-0 grid-overlay opacity-60" />

      <Container className="relative grid items-center gap-12 lg:grid-cols-[1.05fr_1fr]">
        {/* copy */}
        <div className="flex flex-col items-center text-center lg:items-start lg:text-left">
          <Reveal>
            <span className="eyebrow">Interactive Quizzes</span>
          </Reveal>
          <Reveal delay={80}>
            <h1 className="font-heading mt-6 text-[2.3rem] font-bold leading-[1.06] sm:text-[3rem] lg:text-[3.5rem]">
              <span className="head-fade">Interactive Quizzes</span>
              <br />
              <span className="text-accent-grad">Get Smarter</span>
              <br />
              <span className="head-fade">Every Attempt.</span>
            </h1>
          </Reveal>
          <Reveal delay={160}>
            <p className="mx-auto mt-6 w-full max-w-[32rem] text-[0.98rem] leading-relaxed text-white/60 lg:mx-0">
              School Hack auto-generates personalised quizzes directly from your
              notes, slides, and videos. Instant feedback, detailed explanations,
              and a score tracker that shows exactly where you need to improve.
            </p>
          </Reveal>
          <Reveal delay={240}>
            <a
              href={REGISTER_URL}
              target="_blank"
              rel="noreferrer"
              className="btn-primary mt-8 px-7 py-3.5 text-[0.95rem]"
            >
              Try it now
              <ArrowRight size={17} />
            </a>
          </Reveal>
        </div>

        {/* phone */}
        <Reveal delay={200} className="relative mx-auto w-full max-w-[440px]">
          <div className="glow left-1/2 top-1/2 h-[360px] w-[360px] -translate-x-1/2 -translate-y-1/2 bg-accent/16" />
          <img
            src={phone}
            alt="Interactive quiz results on phone"
            className="relative w-full animate-float object-contain drop-shadow-[0_40px_80px_rgba(0,0,0,0.55)]"
          />
        </Reveal>
      </Container>
    </section>
  );
};

export default Hero;
